import { FieldProps } from 'formik';

const getError = (name: string, { touched, errors }: FieldProps['form']) =>
  Boolean(touched[name]) ? (errors[name] as string) : undefined;

export default getError;
